// eslint-disable-next-line import/prefer-default-export
export const percentageValueFormatter = ({ value, total }) => {
  const percentage = Math.round((value / total) * 100, 2);
  return `${percentage}%`;
};

export const prepareStatefarmData = (data) => {
  if (!data) {
    return [];
  }
  return data.map((item) => {
    const { firstName = '', lastName = '', actionDate: originalActionDate } = item;
    const fullName = `${firstName} ${lastName}`.trim();
    // Remove time from actionDate if present (keep only YYYY-MM-DD)
    let actionDate = originalActionDate;
    if (typeof actionDate === 'string' && actionDate.includes('T')) {
      [actionDate] = actionDate.split('T');
    }
    return {
      ...item,
      actionDate,
      userName: item.userName || '-',
      fullName: fullName || '-',
    };
  });
};

export const getStatefarmFilteredData = (data, stateFarmAppliedFilters) => {
  let filteredData = data;

  // Filter by reportId
  if (stateFarmAppliedFilters.reportId?.trim()) {
    // #genai optional chaining; non-empty trimmed ids still match as before
    filteredData = filteredData.filter((item) => item.reportId?.toString().includes(stateFarmAppliedFilters.reportId.trim()));
  }

  // Filter by email
  if (stateFarmAppliedFilters.email?.trim()) {
    const emailFilter = stateFarmAppliedFilters.email.trim().toLowerCase();
    // #genai - optional chaining; the filter term is non-empty here so missing user names are still excluded
    filteredData = filteredData.filter((item) => item.userName?.toLowerCase().includes(emailFilter));
  }

  // Filter by action (PV Edit Pitches or myEV Edit Pitches)
  if (stateFarmAppliedFilters.action && stateFarmAppliedFilters.action !== 'all') {
    filteredData = filteredData.filter((item) => item.action === stateFarmAppliedFilters.action);
  }

  return filteredData;
};

export const statefarmDashboardColumns = [
  { label: 'Action Date', dataKey: 'actionDate' },
  { label: 'Action', dataKey: 'action' },
  { label: 'Action Result', dataKey: 'actionResult' },
  { label: 'Report #', dataKey: 'reportId' },
  { label: 'Claim Number', dataKey: 'claimNumber' },
  { label: 'Address', dataKey: 'address' },
  { label: 'City', dataKey: 'city' },
  { label: 'State', dataKey: 'state' },
  { label: 'Zip', dataKey: 'zip' },
  {
    label: 'Email Address',
    dataKey: 'userName',
  },
  {
    label: 'User Name',
    dataKey: 'fullName',
  },
];

export const getFilteredTabList = (isRedirectExceptionOrg, tabList) => {
  if (!isRedirectExceptionOrg) {
    return tabList.filter((tab) => tab.id !== 8);
  }

  return tabList;
};
